import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-ta-type-checkbox',
    templateUrl: './ta-type-checkbox.component.html',
    styleUrls: ['./ta-type-checkbox.component.scss'],
})
export class TaTypeCheckboxComponent {
    @Input() callbackData: any;
    showCurattionTooltip: boolean = false;
    checkboxChanged(event: any) {
        console.log('CHECKBOX CALLBACK', this.callbackData[0].arg[4]);
        if (this.callbackData) {
            this.callbackData[0].callback(
                this.callbackData[0].arg[0],
                event.checked,
                this.callbackData[0].arg[2],
                this.callbackData[0].arg[3]
            );
        }
    }

    onClick() {
        if (this.callbackData[0].arg[4] === false) {
            this.showCurattionTooltip = true;
            setTimeout(() => {
                this.showCurattionTooltip = false;
            }, 2000);
        }
    }
}

